import { MisConfiguredPage } from "@/pages";
import { FC, ReactNode } from "react";
import { Layout } from "@/components";
import styles from "./styles.scss";
import { configSchema, helmValidation } from "@/guards/helm";

export const ConfigValidationGuard: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { error } = helmValidation(window, configSchema, "configSchema2");

  if (error) {
    return (
      <Layout className={styles.layout}>
        <MisConfiguredPage errors={error} />
      </Layout>
    );
  }

  return <>{children}</>;
};
